import { IQuery } from 'core-ts-types';
import { Query } from 'utility-ts-orm';
import * as _4 from 'lodash4';
import { RequestStateModel } from '../models/request_state_model';
import { IRegistrationSelectedSectionsModel } from '../../views/registration/models/registration_selected_sections_model';
import { RegistrationSelectedSectionsQuery } from '../../views/registration/queries/registration_selected_sections_query';
import { ISection } from '../../interfaces/scheduler_interfaces';

export class RequestStateQuery implements IQuery {
  private _result: {
    scheduledSectionPendingSet: Set<ISection['id']>;
    isSwapPending: boolean;
    isRegistrationPending: boolean;
    isCampusPreferencePending: boolean;
    isMultiSectionsDropWithdrawPending: boolean;
    isMultiSectionsWaitlistPending: boolean;
  };

  constructor(
    private ngRequestStateModel: RequestStateModel,
    private ngRegistrationSelectedSectionsModel: IRegistrationSelectedSectionsModel,
    private ngRegistrationSelectedSectionsQuery: RegistrationSelectedSectionsQuery
  ) {
    Query.registerQuery(this, ngRequestStateModel, ngRegistrationSelectedSectionsModel);
  }

  run() {
    this._result = {
      scheduledSectionPendingSet: this.ngRequestStateModel.read().scheduledSectionPendingSet,
      isSwapPending: this.ngRequestStateModel.read().isSwapPending,
      isRegistrationPending: this.ngRequestStateModel.read().isRegistrationPending,
      isCampusPreferencePending: this.ngRequestStateModel.read().isCampusPreferencePending,
      isMultiSectionsDropWithdrawPending: this.ngRequestStateModel.read().isMultiSectionsDropWithdrawPending,
      isMultiSectionsWaitlistPending: this.ngRequestStateModel.read().isMultiSectionsWaitlistPending
    };
    return this;
  }

  get result() {
    return this._result;
  }
}
angular.module('capability-ng-scheduler').service('ngRequestStateQuery', RequestStateQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/request_state/queries/request_state_query.ts